export const NumberValidation = {
  data() {
    return {
      enter_otp: '',
      timer: 60,
      timerInterval: null,
    }
  },
  methods: {
    validateContactNumberRule(value) {
      const length = value ? value.toString().length : 0;
      if (length !== 0 && length !== 10) {
        return 'Contact number must match 10 digits';
      }
      return true;
    },
    
    validateKey(event) {
      const isNumber = event.key >= '0' && event.key <= '9';
      const isControl = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key);

      const isShortcut = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());

      if (!isNumber && !isControl && !isShortcut) {
        event.preventDefault();
      }
    },
    handlePaste(event, field) {
      event.preventDefault();

      const pastedData = event.clipboardData.getData('text');
      const numericData = pastedData.replace(/\D/g, '');

      this[field] = numericData;
    },
    formatTime(seconds) {
      const remainingSeconds = seconds % 120;
      return `${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }, 

    startTimer() {
      this.timer = 60;
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
  },
};